import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const savedUser = localStorage.getItem('currentUser');
  
  if (savedUser) {
    const user = JSON.parse(savedUser);
    // Priorizamos el token real (JWT), si no existe usamos el simple para compatibilidad
    const token = user.token || btoa(`${user.id}:${user.nombreUsuario}`);
    
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
    return next(authReq);
  }

  return next(req);
};
